import { makeAutoObservable } from 'mobx';
import { v4 as UUID } from 'uuid';

export type MicroCycleConfiguration = {
  id: string;
  microCycleTemplateId: string;
};

export function createMicroCycleConfiguration(json?: Partial<MicroCycleConfiguration>): MicroCycleConfiguration {
  return makeAutoObservable({
    id: json?.id || UUID(),
    microCycleTemplateId: json?.microCycleTemplateId || '',
  });
}
